export const appConfig = {
  facilityId: "IN0610090427",
  drName: "Dr. Mohit Tripathi",
  drRegNum: "NH001"
};
